import { render } from "./OverflowContent.vue?vue&type=template&id=478e3ac0"
import script from "./OverflowContent.vue?vue&type=script&lang=js"
export * from "./OverflowContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__